import { Button } from '@/components/Button';
import { NotifyTrigger } from '@/components/ProductTile';
import { PurchaseAction } from '@/constants';
import * as Styled from './Modal.styled';
import type { ModalTriggerProps } from './types';

export const ModalTrigger = ({
  isCarouselCta,
  isLinkLike,
  trigger,
}: ModalTriggerProps) => {
  if (isCarouselCta) {
    return (
      <NotifyTrigger
        $purchaseAction={PurchaseAction.Notify}
        icon={<>{trigger.icon}<span>{trigger.content}</span></>}
        label={trigger.label}
      />
    );
  }

  if (isLinkLike) {
    return (
      <Styled.ModalTrigger aria-label={trigger.label}>
        {trigger.content}
      </Styled.ModalTrigger>
    );
  }

  return (
    <Button aria-label={trigger.label} icon={trigger.icon}>
      {trigger.content}
    </Button>
  );
};
